import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import CommunityGreetingImage from "./CommunityGreetingImage.js";
import CommunityGreetingImage_2x from "./CommunityGreetingImage@2x.js";
const DEFAULT_ALT_TEXT = 'Сообщество создано! Пригласите первых участников';
const CommunityGreeting = (t0)=>{
    const $ = c(2);
    const { width: t1 } = t0;
    const width = void 0 === t1 ? 260 : t1;
    let t2;
    if ($[0] !== width) {
        t2 = /*#__PURE__*/ jsx("img", {
            alt: DEFAULT_ALT_TEXT,
            src: CommunityGreetingImage,
            srcSet: `${CommunityGreetingImage_2x} 2x`,
            width: width
        });
        $[0] = width;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
};
export { CommunityGreeting };
